import { DateField } from '../../DateField';
import { InputErrorMessage } from '../../InputErrorMessage';
import { Label } from '../../Label';
import type { RangeInputControl } from '../types';

type DateRangePickerInputsProps = {
  fromInputControl: RangeInputControl;
  toInputControl: RangeInputControl;
  fromError?: string;
  toError?: string;
  disabled?: boolean;
};

export function DateRangePickerInputs({
  fromInputControl,
  toInputControl,
  fromError,
  toError,
  disabled,
}: DateRangePickerInputsProps) {
  // Show error message if either field has an error
  const errorMessage = fromError || toError;

  return (
    <div className="flex flex-col gap-0">
      <div className="grid grid-cols-2 gap-2">
        <Label>From</Label>
        <Label className="translate-x-[9px]">To</Label>
      </div>
      <div className="flex items-center gap-2">
        <DateField
          value={fromInputControl.value}
          onChange={fromInputControl.onChange}
          onFocus={fromInputControl.onFocus}
          onBlur={fromInputControl.onBlur}
          disabled={disabled}
          error={fromError}
          showErrorMessage={false}
        />
        <div className="w-4 h-px bg-text-disabled" />
        <DateField
          value={toInputControl.value}
          onChange={toInputControl.onChange}
          onFocus={toInputControl.onFocus}
          onBlur={toInputControl.onBlur}
          disabled={disabled}
          error={toError}
          showErrorMessage={false}
        />
      </div>
      {errorMessage && (
        <div className="mt-2">
          <InputErrorMessage message={errorMessage} />
        </div>
      )}
    </div>
  );
}
